import { t as e } from "../i18n.mjs";
//#region src/utils/format-bytes.ts
function t(t, n = 2, r) {
	if (t < 0) return r?.whenNegative ?? e("file_manager.processing_size");
	if (t === 0) return "0 Bytes";
	let i = 1024, a = n < 0 ? 0 : n, o = [
		"Bytes",
		"KB",
		"MB",
		"GB"
	], s = Math.floor(Math.log(t) / Math.log(i));
	return parseFloat((t / i ** s).toFixed(a)) + " " + o[s];
}
//#endregion
export { t as formatBytes };
